<template>
    <div :class="['audio-player', {'is-playing': playing}]">
        <a href="#" :class="className" @click.prevent="togglePlayButton" :label="useLabel ? useLabel : label">{{ useLabel ? useLabel : label }}</a>
    </div>
</template>
<script>
    export default {
        props: {
            playerId: {
                type: String,
                default: null
            },
            fileId: {
                type: String,
                default: null,
            },
            fileUrl: {
                type: String,
                default: null,
            },
            className: {
                default: 'play'
            },
            useLabel: {
                default: null
            },
            description: {
                default: null
            }
        },
        mounted() {

            var vm = this;

            this.$root.$on('audioElementStarts',data => {
                if (data.fileId && data.fileId == this.fileId) {
                    vm.playing = true;
                }
                if (data.fileUrl && data.fileUrl == this.fileUrl) {
                    vm.playing = true;
                }
            })

            this.$root.$on('audioElementStops',data => {
                vm.playing = false;
            })
        },
        data() {
            return {
                playing: false
            };
        },
        methods: {
            togglePlayButton() {
                this.$root.$emit('togglePlayButton', {
                    fileId:this.fileId,
                    fileUrl:this.fileUrl,
                    description: this.description
                });
            }
        },
        computed: {
            label() {
                return this.playing ? 'pause' : 'play';
            },
        }
    }
</script>
